/* Reveal au scroll — discret, sans dependance.
   Principe de securite : le contenu n'est masque que si CE script tourne
   (il pose .mg-js). Si le JS echoue ou est desactive, tout reste visible. */
(() => {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Regle reduced-motion : on ne masque rien du tout.
  if (reduce.matches || !('IntersectionObserver' in window)) return;

  const items = document.querySelectorAll('.mg-reveal');
  if (!items.length) return;

  root.classList.add('mg-js');

  // Filet de securite : quoi qu'il arrive, tout est visible au bout de 3 s.
  const failsafe = setTimeout(() => {
    document.querySelectorAll('.mg-reveal').forEach((el) => el.classList.add('is-in'));
  }, 3000);

  // Horizon scrolle dans .page-wrapper, pas dans le document. On observe donc
  // ce conteneur quand il existe, sinon la viewport.
  const scroller = document.querySelector('.page-wrapper');
  const useContainer = scroller && scroller.scrollHeight > scroller.clientHeight + 1;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry, i) => {
        if (!entry.isIntersecting) return;
        // Stagger 40ms : sequence lisible sans ralentir la lecture.
        setTimeout(() => entry.target.classList.add('is-in'), i * 40);
        io.unobserve(entry.target);
      });
      if (!document.querySelector('.mg-reveal:not(.is-in)')) clearTimeout(failsafe);
    },
    {
      root: useContainer ? scroller : null,
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.1,
    }
  );

  items.forEach((el) => io.observe(el));
})();
